import { SET_APPROVE_CONTENTS,SET_CONTENTS, SET_NEXT_CONTENTS, SET_CONTENTS_LOADING } from '../actions/types';

const initialState = {
  loading: false,
  contents: [],
  contentApprove: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CONTENTS_LOADING:
      return {
        ...state,
        loading:true
      }
    case SET_NEXT_CONTENTS:
      return {
        ...state,
        contents: action.payload
      }
    case SET_CONTENTS:
      return {
        ...state,
        contents: action.payload
      }
    case SET_APPROVE_CONTENTS:
      return {
        ...state,
        contentApprove: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contentsReducer.js